import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable, of } from 'rxjs';
import { delay, map } from 'rxjs/operators';
import { environment } from "environments/environment";
import { ReportResponse } from "app/core/models/report-response";

@Injectable()
export class ReportService {

  constructor(private readonly _httpClient: HttpClient) { }

  public getReports(filter: string, sortDirection: 'asc' | 'desc'| '', sortField: string, 
                      pageIndex: number, pageSize: number, activeFilters: Object[]): Observable<ReportResponse> {
    
    let allStringFilterAux = [];
    activeFilters.forEach((item, index) => {
      if (item['value'] != null && item['value'] != '') {
        let stringFilterAux = [item['id'],item['value']];
        allStringFilterAux.push(stringFilterAux.join('::'));
      }
    });

    let queryFilter = allStringFilterAux.join('--');

    
    let params = new HttpParams()
    .set('page', pageIndex.toString())
    .set('page_size', pageSize.toString())
    .set('sf', sortField?.toString() ? sortField?.toString() : '')
    .set('s', sortField?.toString() ? sortDirection?.toString().toUpperCase() : '')
    .set('f', queryFilter);

    return this._httpClient.get(`${environment.apiUrl}/reports`, {
      params: params
      }).pipe(
          map(res =>  <ReportResponse>res)
      );
  }

  getReportsList(): Observable < any > {
      return this._httpClient.get(`${environment.apiUrl}/reports`);
  }

  getReportDownload(id: string): Observable <Blob> {
      return this._httpClient.get(`${environment.apiUrl}/reports/${id}/download`, { responseType: 'blob' });
  }

  generateReport(url: string, reason: string): Observable<Blob> {
    return this._httpClient.post(`${environment.apiUrl}${url}`, { reason }, { responseType: 'blob' });
  }
}
